import {createSvgIcon} from '../create-svg-icon';

export const DensityMediumIcon = createSvgIcon(
  <path d="M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3z" />
, 'DensityMediumOutlined');
